<template>
    <div>
        <FormVueSelect append-to-body hide-errors :searchable="false" v-model="selectedValues" max-height="200" class="!tw-h-fit"
            :options="options" option-value="value" :label="$t('common.with_penalty')" :error="errors.with_penalty &&
                $t('errors.' + errors.with_penalty, {
                    field: $t('common.with_penalty'),
                })
                ">
            <template v-slot:option="{ option }">
                <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{
                    option.label }}</p>
            </template>
            <template v-slot:selected-option-container="{ params }">
                <div class="vs__selected tw-text-xs tw-py-0 tw-px-2" :class="params.option.color" @click="removeValue(params.option.id)">
                    <p class="tw-max-w-[90px] tw-truncate">{{ params.option.label }}</p>
                    </div>
            </template>
        </FormVueSelect>
    </div>
</template>

<script setup>
import FormVueSelect from "@/components/form/FormVueSelect";
import { ref, watch, inject } from 'vue';
import { useI18n } from "vue-i18n";

const i18n = useI18n();
const updateFilters = inject('update:filters')
const filters = inject('filters')

const options = [
    { label: i18n.t('common.all'), value: 'all' },
    { label: i18n.t('common.with_penalty'), value: 'with_penalty'},
    { label: i18n.t('common.without_penalty'), value: 'without_penalty' }
];

const errors = ref({})
const selectedValues = ref(filters.value.with_penalty || 'all');

watch(() => selectedValues.value, () => {
    const newFilters = {
        ...filters.value,
        with_penalty: selectedValues.value,
    }

    updateFilters(newFilters)
})

const removeValue = value => {
    selectedValues.value = selectedValues.value.filter(v => v != value)
}

</script>

<style></style>